/**
 * Reglas de puntos del Club que se usan en mas de un lugar (historial de puntos
 * y resumen de la home), centralizadas para que no se desincronicen.
 */

/**
 * Vencimiento de los puntos de una compra:
 *  - Argentina: exactamente un año despues de la compra.
 *  - Colombia: un año despues, redondeado al ultimo dia de ese mes (a mes
 *    cerrado).
 */
export function vencimientoDePuntos(fechaCompra : Date, countryCode : string | null | undefined) : Date {

  const v = new Date(fechaCompra.getTime());
  v.setFullYear(v.getFullYear() + 1);

  if ((countryCode ?? 'AR').toUpperCase() === 'CO') {
    // Dia 0 del mes siguiente = ultimo dia del mes actual.
    return new Date(v.getFullYear(), v.getMonth() + 1, 0);
  }

  return v;
}

/** Ultimo dia del mes de una fecha, a las 23:59:59. */
export function finDeMes(fecha : Date) : Date {
  return new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0, 23, 59, 59);
}
